import React from "react";
import InfoBox from "./../shared/InfoBox";
import List from "../shared/collections/List";
import styles from "../../assets/css/modules/makeAClaim/does-not-require-authorisation.css";
import Store from "./../../content/Store";
import { connect } from "react-redux";
import Contentify from "../../content/Contentify";
import GetStartedButton from "./GetStartedButton";
import IsNewClaimForCondition from "./IsNewClaimForCondition";

export const mapStateToDoesNotRequireAuthorisation = (state) => {
  return {
    isNewClaim: state.makeAClaimReducer.isNewClaim,
    authoriseTreatmentCondition: state.makeAClaimReducer.authoriseTreatmentCondition
  };
};
export const DoesNotRequireAuthorisation = (props) => {
  return (
    <React.Fragment>
      {props.authoriseTreatmentCondition === 'isMusclesBonesJointsCondition' && (
        <React.Fragment>
          <div className="mt-5">
            <IsNewClaimForCondition />
          </div>
        </React.Fragment>
      )}

      <div className={styles.submissionInformation}>
        <InfoBox
          iconClass={
            props.content.infoBoxIconClass +
            " " +
            styles.iconStyle +
            " d-none d-sm-block d-xs-block"
          }
        >
          <p>{props.content.doesNotRequireAuthorisationLabel}</p>
          <List
            customStyle={styles.listStyle}
            data={
              props.isNewClaim
                ? props.content.doesNotRequireAuthorisationCheckListForNewClaim
                : props.content
                  .doesNotRequireAuthorisationCheckListForExistingClaim
            }
          />
          <p>{props.content.phinNotice}</p>
          <p>
            <strong>{props.content.doesNotRequireAuthorisationSLA}</strong>
          </p>
        </InfoBox>
        <GetStartedButton />
      </div>
    </React.Fragment>
  );
};

DoesNotRequireAuthorisation.content = Store.DoesNotRequireAuthorisation;

export default connect(mapStateToDoesNotRequireAuthorisation)(
  Contentify(DoesNotRequireAuthorisation)
);
